import { ReactNode, useEffect, MouseEvent } from 'react';
import { createPortal } from 'react-dom';
import { Icon } from './Icon';
import { IconButton } from './Button';

interface ModalProps {
  open: boolean;
  onClose: () => void;
  title: ReactNode;
  children: ReactNode;
  maxWidth?: number;
  footer?: ReactNode;
}

export const Modal = ({
  open,
  onClose,
  title,
  children,
  maxWidth = 520,
  footer,
}: ModalProps) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const onBackdropClick = (e: MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose();
  };

  return createPortal(
    <div className="modal-backdrop" onClick={onBackdropClick}>
      <div className="modal" style={{ maxWidth }} role="dialog" aria-modal="true">
        <div className="modal-head">
          <div className="modal-title">{title}</div>
          <IconButton onClick={onClose} aria-label="Close">
            <Icon name="x" size={16} />
          </IconButton>
        </div>
        <div className="modal-body">
          {children}
          {footer && <div className="modal-foot">{footer}</div>}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default Modal;
